module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white@2x-12c13d849bebaaba426bee4367074eb1.png";